// Shim for @tabler/icons-react — only re-exports the icons actually used by our app.
// @cmpsr/components does `require("@tabler/icons-react")` which pulls ALL 4,968 icons.
// This alias intercepts the barrel import and provides only the ones we need (~3 KB vs 3.1 MB).
//
// HOW TO ADD A NEW ICON:
// 1. Find the icon name at https://tabler.io/icons
// 2. Add a line: export { default as IconName } from '@tabler/icons-react/dist/esm/icons/IconName.js';
// 3. Run the app and verify the icon renders.
//
// To find missing icons: grep source for Icon imports from @cmpsr/components,
// and check ALERT_ICONS / CloseButton internals in the pre-bundled cmpsr chunk.

// --- Icons imported directly in our source code ---
// @ts-expect-error — individual icon files lack .d.ts; types come from @cmpsr/components wrappers.
export { default as IconArrowRight } from '@tabler/icons-react/dist/esm/icons/IconArrowRight.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconArrowLeft } from '@tabler/icons-react/dist/esm/icons/IconArrowLeft.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconArrowDown } from '@tabler/icons-react/dist/esm/icons/IconArrowDown.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconArrowUp } from '@tabler/icons-react/dist/esm/icons/IconArrowUp.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconPlus } from '@tabler/icons-react/dist/esm/icons/IconPlus.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconInfoCircle } from '@tabler/icons-react/dist/esm/icons/IconInfoCircle.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconChevronDown } from '@tabler/icons-react/dist/esm/icons/IconChevronDown.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconChevronRight } from '@tabler/icons-react/dist/esm/icons/IconChevronRight.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconCheck } from '@tabler/icons-react/dist/esm/icons/IconCheck.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconEdit } from '@tabler/icons-react/dist/esm/icons/IconEdit.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconDownload } from '@tabler/icons-react/dist/esm/icons/IconDownload.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconLogout } from '@tabler/icons-react/dist/esm/icons/IconLogout.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconMenu2 } from '@tabler/icons-react/dist/esm/icons/IconMenu2.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconAlertCircle } from '@tabler/icons-react/dist/esm/icons/IconAlertCircle.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconX } from '@tabler/icons-react/dist/esm/icons/IconX.js';

// --- Icons used internally by @cmpsr/components (Alert, CloseButton, etc.) ---
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconAlertTriangle } from '@tabler/icons-react/dist/esm/icons/IconAlertTriangle.js';
// @ts-expect-error — no .d.ts for individual icon files
export { default as IconCircleCheck } from '@tabler/icons-react/dist/esm/icons/IconCircleCheck.js';

// Safety net: returns a no-op component for any un-shimmed icon to prevent crashes.
// In dev mode, logs a warning so missing icons are easy to spot and add.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NoopIcon = (_props: any) => null;
NoopIcon.displayName = 'NoopIcon';

const handler: ProxyHandler<Record<string, unknown>> = {
  get(target, prop) {
    if (typeof prop === 'string' && prop in target) {
      return target[prop];
    }
    if (typeof prop === 'string' && prop !== '__esModule' && prop.startsWith('Icon')) {
      if (import.meta.env.DEV) {
        console.warn(`[shim] Rendering fallback for un-shimmed icon "${prop}". Add it to src/shims/tabler-icons-shim.ts if it should be visible.`);
      }
      return NoopIcon;
    }
    return target[prop as string];
  },
};

export default new Proxy<Record<string, unknown>>({}, handler);
